<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="身份证号" prop="idCard">
                <Input
                  v-model="query.idCard"
                  clearable
                  placeholder="请输入身份证号"
                  maxlength="18"
                />
              </form-item>
            </i-col>
            <!-- <i-col span="6">
                <form-item label="男方身份证号" prop="cert_num_man">
                  <Input
                    v-model="query.cert_num_man"
                    clearable
                    placeholder="请输入男方身份证号"
                    maxlength="18"
                  />
                </form-item>
              </i-col>
              <i-col span="6">
                <form-item label="女方姓名" prop="name_woman">
                  <Input
                    v-model="query.name_woman"
                    clearable
                    placeholder="请输入女方姓名"
                    maxlength="10"
                  />
                </form-item>
              </i-col>
              <i-col span="6">
                <form-item label="女方身份证号" prop="cert_num_woman">
                  <Input
                    v-model="query.cert_num_woman"
                    clearable
                    placeholder="请输入女方身份证号"
                    maxlength="18"
                  />
                </form-item>
              </i-col> -->
          </row>
        </i-form>
      </div>
      <div class="table-data">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader"
            :border="true"
            :loading="isLoading"
            :data="info"
            stripe
            ref="table"
            height="500"
          >
            <template slot-scope="{ row, index }" slot="action"> </template>
          </i-table>
        </div>
      </div>
    </div>

    <!-- <div class="content" v-if="info">
        <div class="search">
          <Form>
            <row :gutter="80" v-for="itme in info">
              <i-col span="8" v-for="(data, key) in itme">
                <FormItem :label="key + ':'">
                  <div class="detail">{{ data }}</div>
                </FormItem>
              </i-col>
            </row>
          </Form>
        </div>
      </div> -->
  </div>
</template>
  
  <script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { rkMessVerification } = api;
export default {
  name: "marriageRegister",
  components: {
    pageHead,
  },

  data() {
    return {
      query: {
        idCard: "",
        userName: "濮阳市",
        userDeptCode: "410900",
      },
      info: undefined,
      isLoading: false,
      tableHeader: [
        { title: "姓名", key: "popName", align: "center" },
        { title: "身份证号", key: "idCard", align: "center" },
        { title: "出生日期", key: "popBirthDate", align: "center" },
        {
          title: "性别",
          key: "popGender",
          align: "center",
          render: (h, params) => {
            console.log(params)
            return h("div", [
              h("span", (params.row.popGender == "1" ? "男" : "女")),
            ]);
          },
        },
        {
          title: "民族",
          key: "popNation",
          align: "center",
        },
        { title: "现居住地", key: "popAddr", align: "center" },
        { title: "有效期限自", key: "yxqqsrq", align: "center" },
        { title: "有效期限至", key: "yxqjzrq", align: "center" },
      ],
      title: "人口信息核验查询",
      btnList: [
        {
          name: "重置",
          type: "reset",
        },
        {
          name: "查询",
          type: "search",
        },
      ],
    };
  },
  methods: {
    handleBtn(type) {
      if (type == "reset") {
        this.query.idCard = "";

        this.$refs.search.resetFields();
      } else if (type == "search") {
        this.marriageRegister();
      }
    },
    async marriageRegister() {
      if (!this.query.idCard) {
        return this.$Message.warning("请输入身份证号");
      }

      this.isLoading = true;
      try {
        let data = {
          idCard: this.query.idCard,
          userName: this.query.userName,
          userDeptCode: this.query.userDeptCode,
        };
        console.log(data);
        let res = await this.$get(rkMessVerification, data);
        console.log(JSON.parse(res));
        if (res) {
          this.info = [JSON.parse(res).resultData];
        } else {
          this.info = undefined;
        }
      } finally {
        this.isLoading = false;
      }
      console.log(this.query);
    },
  },
  created() {},
  mounted() {},
};
</script>
  
  <style lang="less" scoped>
.content {
  margin: 20px;
}

.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.label {
  width: 100px;
}

.time {
  width: 100%;
}
</style>
  